export default __webpack_public_path__ + "static/media/rightLayer.7cd1d19b.svg";